import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Modal, Typography } from '@material-ui/core';
import SpinnerComponent from '../../../components/SpinnerComponent';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: theme.spacing(4),
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(4),
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
  },
}));

export default function LoadingModal(props) {
  const classes = useStyles();

  return (
    <Modal open={props.open} className={classes.modal}>
      <div className={classes.modalContainer}>
        <Typography variant="h6">{props.testo}</Typography>
        <SpinnerComponent size={32} />
      </div>
    </Modal>
  );
}

LoadingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  testo: PropTypes.string.isRequired,
};
